import axios from "axios";
import config from "../config";

export const getJob = async (id) => {
    const response = await axios.get(`${config.API_BASE_URL}/job/get`, { 
        params: {
            id
        }
    });
    if (response != null) {
        return response.data;
    }
    return null;
}

export const getJobs = async () => {
    const response = await axios.get(`${config.API_BASE_URL}/job/all`);
    if (response != null) {
        return response.data;
    }
    return null;
}

export const createJob = async (data) => {
    const response = await axios.post(`${config.API_BASE_URL}/job/create`, data);
    if (response != null) {
        return response.data;
    }
    return null;
}

export const updateJob = async (data) => {
    const response = await axios.post(`${config.API_BASE_URL}/job/update`, data);
    if (response != null) {
        return response.data;
    }
    return null;
}

export const deleteJob = async (data) => {
    const response = await axios.post(`${config.API_BASE_URL}/job/delete`, data);
    if (response != null) {
        return response.data;
    }
    return null;
}